<template>
    <div>
        <card-header title="New Event Description" icon="fa-plus"/>

        <card-body>
            <event-description-form :description="newDescription"/>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" :disabled="!newDescription.title || !newDescription.description" @click="submit"><i class="fas fa-plus mr-3"></i>New Event Description</b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import EventDescriptionForm from "./EventDescriptionForm";

    import {client as http} from '@/http_client';

    export default {
        props: ['card', 'child', 'props'],
        components: {EventDescriptionForm, CardFooter, CardBody, CardHeader},
        data: function() {
            return {
                newDescription: {
                    event_type: null,
                    title: '',
                    description: ''
                }
            };
        },
        methods: {
            submit() {
                this.$emit('loading', true);
                http.post('/api/event_descriptions', this.newDescription, {force: true}).then(response => {
                    this.$reloadCard('event-descriptions');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.$saveAlert(true, 'Are you done creating this event description? Unsaved changes will be lost.');
        }
    };
</script>
